var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tab border-1px"},[_c('router-link',{attrs:{"to":"/goods"}},[_vm._v("商品")]),_vm._v(" "),_c('router-link',{attrs:{"to":"/ratings"}},[_vm._v("评价")]),_vm._v(" "),_c('router-link',{attrs:{"to":"/seller"}},[_vm._v("商家")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-58f2a47e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/tab/tab.vue
// module id = null
// module chunks = 